<template>
  <div>
    <ul>
      <!-- Pagseguro Payment -->
      <li v-if="isReal">
        <vs-radio v-model="paymentMethod" vs-value="pagseguro" @change="changeValue" class="my-1">
          <div class="flex items-center">
            <img src="@/assets/images/logo/payment-pagseguro.png" alt="bank-logo" width="110" class="inline-flex">
            <span>{{ $t('pages.shop.checkout.tab3.pagseguro') }}</span>
          </div>
        </vs-radio>
      </li>

      <!-- Pix payment -->
      <li v-if="currency === 'BRL' && false">
        <vs-radio v-model="paymentMethod" vs-value="pix" @change="changeValue" class="my-1">
          <div class="flex items-center">
            <img src="@/assets/images/logo/payment-pix.png" alt="bank-logo" :width="65" class="inline-flex">
            <span>{{ $t('pages.shop.checkout.tab3.pix') }}</span>
          </div>
        </vs-radio>
      </li>

      <!-- PAYPAL Payment-->
      <li v-if="isDollar">
        <vs-radio v-model="paymentMethod" vs-value="paypal" @change="changeValue" class="my-1">
          <img src="@/assets/images/logo/payment-paypal.png" alt="bank-logo" height="35" width="110" class="inline-flex">
          <span>{{ $t('pages.shop.checkout.tab3.paypal') }}</span>
        </vs-radio>
      </li>

      <!-- Maquininha payment -->
      <li v-if="this.$store.getters['Profile/isCreditCardEnable']">
        <vs-radio v-model="paymentMethod" vs-value="physical" @change="changeValue" class="my-1">
          <img src="@/assets/images/logo/payment-physical.png" alt="bank-logo" :height="35" :width="55" class="inline-flex">
          <span>{{ $t('pages.shop.checkout.tab3.physical') }}</span>
        </vs-radio>
      </li>

      <!-- Dental Prev payment -->
      <li v-if="this.$store.getters['Profile/isDentalPrevEnable']">
        <vs-radio v-model="paymentMethod" vs-value="dentalPrev" @change="changeValue" class="my-1">
          <img src="@/assets/images/logo/payment-dentalPrev.png" alt="bank-logo" :height="35" :width="55" class="inline-flex">
          <span>{{ $t('pages.shop.checkout.tab3.dentalPrev') }}</span>
        </vs-radio>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: "PaymentChoose",
  props: {
    currency: { //Need this one, because admin can create a new transaction in BRL or Dolar
      type: String, //Can be USD or BRL
      required: true
    },
    value: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      paymentMethod: null
    }
  },
  watch: {
    value() {
      this.paymentMethod = this.value;
    }
  },
  computed: {
    isReal() {
      return this.currency === 'BRL';
    },
    isDollar() {
      return this.currency === 'USD';
    }
  },
  methods: {
    changeValue() {
      this.$emit('input', this.paymentMethod);
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
